module.exports = __webpack_public_path__ + "static/media/AB_P7_8.564e6d71.jpg";